import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { JobLiveEntity } from '../../domain/entities/JobLiveEntity'
import type { MonitoringJobAdminDto } from '@/backend/market'
export class JobLiveModel extends JobLiveEntity {
  constructor(dataDto: MonitoringJobAdminDto) {
    super()
    mapEntityProperties<JobLiveEntity>(this, dataDto, {
      map: {
        branch: dataDto.branchAdminDto,
        driver: dataDto.driverDto
      }
    })
  }
}
